import { useEffect, useState } from 'react';
import './PageFooter.css';
import {
  KIOSK_POWERED_BY_CHANGED_EVENT,
  shouldShowKioskPoweredBy,
} from '../../shared/kioskPoweredBy';

/**
 * Page Footer Component
 * Displays the NYAFAZ logo when the organization has powered-by enabled.
 * Always mounted from NaturalsSalonFlowLayout — never skip by route.
 */
const PageFooter = () => {
  const [show, setShow] = useState(() => shouldShowKioskPoweredBy());

  useEffect(() => {
    const sync = () => setShow(shouldShowKioskPoweredBy());
    sync();
    window.addEventListener(KIOSK_POWERED_BY_CHANGED_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(KIOSK_POWERED_BY_CHANGED_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  if (!show) return null;

  return (
    <footer className="naturals-kiosk-powered-by">
      <div className="footer-content">
        <div className="footer-logo-container">
          <span className="powered-by-text">Powered by</span>
          <a href="https://nyafaz.com/" aria-label="Visit NYAFAZ website">
            <img
              src={`${process.env.PUBLIC_URL}/footer.png`}
              alt="NYAFAZ logo"
              className="footer-logo"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default PageFooter;
